<template>
  <section>
    <PageTitle title="Live Statuses" v-if="!hidePageTitle"
               v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/live_status_of_branches',title:'Live Statuses'}]"
    />
  </section>
</template>

<script>
import PageTitle from "../components/layout_components/PageTitle";

export default {
  name: "LiveStatusofBranches",
  components: {
    PageTitle
  },
  data() {
    return {}

  },
  props: {
    hidePageTitle: {
      type: Boolean,
      default: false,
    }
  },
}
</script>

<style scoped>

</style>